// import React from 'react';
import styled from 'styled-components';

/*

Props:
• backgroundURL
• width
• height

*/

export const StyledLogo = styled.div`
    display: flex;
    background-image: ${props => (props.backgroundURL) ? 'url('+props.backgroundURL+')' : 'url(https://firebasestorage.googleapis.com/v0/b/cyno-5e3a9.appspot.com/o/CynoLogos%2FCyno_Logo-Wordmark_Colour.png?alt=media&token=ed48b461-00c6-40cc-a51f-3838e877bf2c)'};
    background-repeat: no-repeat;
    background-size: cover;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 12px;
    width: ${props => (props.width) ? props.width+'px' : '150px'};
    height: ${props => (props.height) ? props.height+'px' : '63px'};

`;




// WEBPACK FOOTER //
// ./src/js/components/StyledLogo.jsx